<template>
	<div class="text-left" v-if="bet">
		<div class="row">
			<div class="col-6">

				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.status }}
					</div>
					<template v-if="bet.result">
						<template v-if="bet.result.key == 'waiting'">
							<span class="status-pill yellow smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
						</template>
						<template v-if="bet.result.key == 'win' || bet.result.key == 'refund'">
							<span class="status-pill green smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
						</template>
						<template v-if="bet.result.key == 'loss'">
							<span class="status-pill red smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
						</template>
						<template v-if="bet.result.key == 'cancelled'">
							<span class="status-pill blue smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
						</template>
					</template>
				</div>
			</div>
			<div class="col-6">
				<div class="listy b-b">
					<div class="label">{{ t.created_at }}</div>
					{{ bet.created_at | moment('D MMM ddd HH:mm:ss', session.timezone) }}
				</div>
			</div>
			<div class="col-6">
				<div class="listy b-b">
					<div class="label">{{ t.last_transaction }}</div>
					{{ bet.updated_at | moment('D MMM ddd HH:mm:ss', session.timezone) }}
				</div>
			</div>
			<div class="col-6">
				<div class="listy b-b">
					<div class="label">App</div>
					{{ bet.app.username }}
				</div>
			</div>
			<div class="col-6">
				<div class="listy b-b">
					<div class="label">{{ t.betting.title.amount_per_bet }}</div>
					{{ bet.amount_per_bet | toMoney(bet.currency) }}
				</div>
			</div>
			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.payed }}
					</div>
					{{ bet.amount | toMoney(bet.currency) }}
				</div>
			</div>

			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.multiplier }}
					</div>
					{{ bet.multiplier }}
				</div>
			</div>

			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.bet_type }}
					</div>
					<span class="text-success">
						{{ t.betting.type[bet.type.name] }}
						<span v-if="bet.type.name == 'system'">
							({{ bet.combinations }})
						</span>
					</span>
				</div>
			</div>

			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.earnings }}
					</div>
					{{ bet.earnings | toMoney(bet.currency) }}
				</div>
			</div>

			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.bet_count }}
					</div>
					{{ bet.bet_count }}
				</div>
			</div>
			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.odd_count }}
					</div>
					{{ bet.odd_count }}
				</div>
			</div>

			<div class="col-6">
				<div class="listy b-b">
					<div class="label">
						{{ t.betting.title.waiting_bets }}
					</div>
					{{ bet.wait_count }}
				</div>
			</div>
		</div>

		<div class="element-wrapper">
			<h6 class="element-header">{{ t.navigation.bets }}</h6>
			<div class="element-content">
				<div class="pipeline white" v-for="item in items" :class="betClass(item.oddResult)">
					<div class="pipeline-body">
						<div class="row">
							<div class="col-12">
								<scoreboard v-if="item.radarId > 0" collapseTo="scoreboard" layout="mini" :matchId.sync="item.radarId" />
                <table class="table table-compact smaller b-b" v-if="items">
                  <thead>
                  <tr>
                    <th colspan="5" class="text-warning text-center">({{ item.matchStartDate | moment('DD MMM dddd HH:mm', session.timezone) }})</th>
                  </tr>
                  <tr>
                    <th>{{item.sportName}} > {{ item.regionName }} > {{ item.competitionName }}</th>
                    <th class="text-center">HT</th>
                    <th class="text-center">FT</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <router-link :to="{name: 'fixture', params: {id: item.mid}}">
                      <img width="20" height="20" :src="'https://ls.sportradar.com/ls/crest/medium/'+item.fcExtendedId+'.png'"/> {{ item.fcName | slimiter(20) }} <br />
                      <img width="20" height="20" :src="'https://ls.sportradar.com/ls/crest/medium/'+item.scExtendedId+'.png'"/> {{ item.scName | slimiter(20) }}
                      </router-link>
                    </td>
                    <td class="text-center w50">
							<span v-if="mData(item.matchStats).hasOwnProperty('1st half')">
								{{ item.matchStats['1st half'].score.home }} - {{ item.matchStats['1st half'].score.away }}
							</span>
                    </td>
                    <td class="text-center w50">
							<span v-if="mData(item.mData).hasOwnProperty('score')">
								{{ mData(item.mData).score.home }} - {{ mData(item.mData).score.away }}
							</span>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
							<div class="col-12">
								<div class="listy b-b">
									<span class="label">
										{{ t.betting.title.status }}
									</span>
									<select v-on:change="regenerateBet(item.selectionId, item.oddResultId)" class="form-control form-control-sm rounded col-11 pull-left" v-model="item.oddResultId" v-if="betStatus">
										<option :value="result.id" v-for="result in betStatus" >{{ result.name }}</option>
									</select>
									<div class="pull-right">
										<router-link :to="{name: 'fixture', params: {id: item.mid}}" target="_blank">
											<i class="os-icon os-icon-arrow-right3"></i>
										</router-link>
									</div>
								</div>
							</div>
							<div class="col-12" v-if="!item.statsId">
							<table class="table table-compact smaller b-b" v-if="items">
								<thead>
								<tr>
									<th>{{item.sportName}} > {{ item.regionName }} > {{ item.competitionName }}</th>
									<th class="text-center">HT</th>
									<th class="text-center">FT</th>
								</tr>
								</thead>
								<tbody>
								<tr>
									<td>
										<img width="20" height="20" class="pull-left mr-2" :src="'https://ls.sportradar.com/ls/crest/medium/'+item.fcExtendedId+'.png'"/> {{ item.fcName | slimiter(20) }}
									</td>
									<td class="text-center w50">
										<span v-if="mData(item.mData).hasOwnProperty('score_ht')">
											{{ mData(item.mData).score_ht.home }}
										</span>
									</td>
									<td class="text-center w50">
										<span v-if="mData(item.mData).hasOwnProperty('score')">
											{{ mData(item.mData).score.home }}
										</span>
									</td>
								</tr>
								<tr>
									<td>
										<img width="20" height="20" class="pull-left mr-2" :src="'https://ls.sportradar.com/ls/crest/medium/'+item.scExtendedId+'.png'"/> {{ item.scName | slimiter(20) }}
									</td>
									<td class="text-center w50">
										<span v-if="mData(item.mData).hasOwnProperty('score_ht')">
											{{ mData(item.mData).score_ht.away }}
										</span>
									</td>
									<td class="text-center w50">
										<span v-if="mData(item.mData).hasOwnProperty('score')">
											{{ mData(item.mData).score.away }}
										</span>
									</td>
								</tr>
								</tbody>
							</table>
						</div>
						<div class="col-sm-4 col-lg-4" v-if="item.isLive">
							<div class="listy mb-0">
								<span class="label">
									{{ t.time_period }}
								</span>
								{{ item.betResult }}
								<span class="pull-right" v-if="item.hasOwnProperty('periodTime')">
										<i class="icon-clock"></i> {{ periodTimer(item) }}
								</span>
								<span v-if="mData(item.betData).hasOwnProperty('score')">
									({{ mData(item.betData).score.home }} - {{ mData(item.betData).score.away }})
								</span>
							</div>
						</div>
						<div :class="(item.isLive) ? 'col-sm-12 col-lg-5' : 'col-sm-12 col-lg-9'">
							<div class="listy mb-0">
									<span class="label">
										{{ item.name }}
									</span>
								{{t.bet_selection}}: {{ item.selection }}
								<span class="text-success pull-right">{{ item.oddValue }}</span>
							</div>
						</div>
						<div class="col-sm-4 col-lg-3 text-center">
							<template v-if="item.oddResult == 'waiting'">
							<span class="status-pill yellow smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
							</template>
							<template v-if="item.oddResult == 'win' || item.oddResult == 'refund'">
							<span class="status-pill green smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
							</template>
							<template v-if="item.oddResult == 'loss'">
							<span class="status-pill red smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
							</template>
							<template v-if="item.oddResult == 'cancelled'">
							<span class="status-pill blue smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	</div>
</template>

<script>

    import scoreboard from '@/components/stats/widget/scoreboard'
    import betActions from '@/components/user/bets/betActions'
    import betManager from '@/mixins/betmanager'
    export default {
        name: 'betDetail',
        components: {betActions, scoreboard},
	    mixins: [betManager],
        props: {
            betid: {
                default: 0,
                type: Number
            }
        },
        data () {
            return {
                session: this.$root.session,
                t: this.$root.t,
                items: [],
                bet: null,
                notfound: false,
                betStatus: null
            }
        },
        mounted () {
            this.fetchBets();

            this.fetchBetStatus().then(response => {
                this.betStatus = response.body
            })
        },
        watch: {
            'betid' () {
                this.fetchBets();
            }
        },
        methods: {
            onChangePage (page) {
                this.pagination.current = page;
                this.filter.page = page;
                this.$router.push({ query: {} });
                this.$router.push({ query: {page: page} });

                window.scroll(0, 0);
            },
            async fetchBets () {
	            this.$http.get(bsapi+'api/v1/bet/detail/'+this.betid)
	            .then(response => {

		            this.bet = response.body.result.bet;
			        this.items = response.body.result.items;
		        }, response => {
		            this.notfound = 1;
		        })
		    },
		    betClass (result) {
		        if (result == 'waiting') {
		            return 'lined-warning';
		        }
		        if (result == 'cancelled') {
		            return 'lined-primary';
		        }
		        if (result == 'win' || result == 'refund') {
		            return 'lined-success';
		        }
		        if (result == 'loss') {
		            return 'lined-danger';
		        }
		    },
		    mData (data) {
		        return data;
		    }
    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.nav-link span {
		display: inline-block;
	}
	.team-repeat {
		width: 120px;
		text-align: left;
	}
	.team-repeat img{
		margin-right: 5px;
	}
	.amount-b {
		min-width: 30%;
		float: right;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/account/betDetail.vue